import { PRODUCT_CATEGORIES, ETC_CATEGORY } from '../config/appConfig';

// Firestore Timestamp / Date / 문자열 → ms (없으면 0 = 맨 뒤)
const toMillis = (v) => {
  if (!v) return 0;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (typeof v.seconds === 'number') return v.seconds * 1000;
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};

// 최근 등록 상품이 맨 앞에 오도록 정렬 (createdAt 없는 레거시 상품은 뒤로)
export const sortProductsByNewest = (list = []) =>
  [...list].sort((a, b) => toMillis(b.createdAt) - toMillis(a.createdAt));

// 기본 대분류 + 상품에 실제로 쓰인 직접입력 분류를 합친 탭 목록
export const getCategoryTabs = (products = []) => {
  const base = Object.keys(PRODUCT_CATEGORIES);
  const extra = [];
  products.forEach(p => {
    const c = p.category1 || p.category;
    if (c && !base.includes(c) && !extra.includes(c)) extra.push(c);
  });
  // '기타'는 항상 마지막에
  const fixed = base.filter(c => c !== ETC_CATEGORY);
  return [...fixed, ...extra, ETC_CATEGORY];
};
